const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
  <defs>
    <linearGradient id="roboGrad" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#E2F0FF" />
      <stop offset="100%" stop-color="#B8D8FF" />
    </linearGradient>
  </defs>

  <path d="M 40 38 L 10 20 A 30 30 0 0 0 10 56 Z" fill="#4ECB71" opacity="0.3"/>

  <path d="M 25 60 Q 15 70, 25 85" fill="none" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>
  <path d="M 75 60 Q 85 70, 75 85" fill="none" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>

  <rect x="35" y="55" width="30" height="30" rx="8" fill="url(#roboGrad)" stroke="#2B3A55" stroke-width="4"/>

  <rect x="25" y="20" width="50" height="35" rx="12" fill="url(#roboGrad)" stroke="#2B3A55" stroke-width="4"/>

  <line x1="50" y1="20" x2="50" y2="10" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>
  <circle cx="50" cy="8" r="4" fill="#4ECB71" stroke="#2B3A55" stroke-width="2"/>

  <circle cx="60" cy="38" r="4" fill="#2B3A55"/>

  <circle cx="40" cy="38" r="6" fill="none" stroke="#4ECB71" stroke-width="2"/>
  <circle cx="40" cy="38" r="2" fill="#4ECB71"/>
</svg>`;

export const search = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
